import type { AddFlagProps } from '@databases/flags-types';
import MentionIcon from '@databases/icons/migration/mention';
import React from 'react';

import { type ContentTypesFlagProps } from '@canvas/frame-api-types';

import { BaseMentionBuilder } from './baseMentionBuilder.ts';
import { messages } from './i18n.ts';
import { type MentionBuilder } from './types.ts';
import { getDisplayNameForUsers } from './utils/getDisplayNameForUsers.ts';

export class RestrictionsFlagForTwoUsers
  extends BaseMentionBuilder
  implements MentionBuilder
{
  shouldShowFlag(): boolean {
    return this.usersWithoutAccess.length === 2;
  }
  build(): AddFlagProps & ContentTypesFlagProps {
    const { displayName, somebodyElse } = getDisplayNameForUsers({
      users: this.usersWithoutAccess
    });

    return {
      id: `restrictions-flag-for-two-users-${this.contentId}`,
      type: 'custom',
      iconString: 'mention',
      title: this.formatMessage(
        messages['mention-notification.flag-permission-restriction-title-two-users'],
        {
          displayName,
          somebodyElse
        }
      ),
      description: this.formatMessage(
        messages['mention-notification.flag-permission-mixed-restriction-description']
      ),
      icon: () => <MentionIcon label="" />
    };
  }
}
